/* Phoenix product page — mirrors the prototype's behaviour (index.tsx) without React:
   gallery thumbnails, Size select + Bundle rows → variant, "Add to cart · $price", sticky cart bar once the
   main button scrolls out, size-guide dialog and quiz entry events for the pixel. Works with Sense's <product-form>. */
(function () {
  'use strict';

  function money(cents) {
    var n = cents / 100;
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function init(root) {
    var dataEl = root.querySelector('[data-phx-product]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var names = product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var sizeIdx = names.indexOf('Size');
    var packIdx = names.indexOf('Pack');
    var form = root.querySelector('product-form form, form[action*="/cart/add"]');
    var idInput = form && form.querySelector('input[name="id"]');
    var submit = form && form.querySelector('[type="submit"]');
    var submitLabel = submit && (submit.querySelector('span:not(.loading__spinner):not(.svg-wrapper)') || submit);
    var sizeSelect = root.querySelector('[data-phx-size-select]');
    var packBtns = root.querySelectorAll('[data-phx-pack]');
    var sticky = document.querySelector('[data-phx-sticky]');
    var state = { size: sizeSelect ? sizeSelect.value : null, pack: null };

    function find(size, pack) {
      return product.variants.find(function (v) {
        return (sizeIdx < 0 || v.options[sizeIdx] === size) && (packIdx < 0 || v.options[packIdx] === pack);
      }) || null;
    }

    function render() {
      var v = find(state.size, state.pack);
      packBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.phxPack === state.pack ? 'true' : 'false');
        var pv = find(state.size, b.dataset.phxPack); var p = b.querySelector('[data-phx-tier-price]');
        if (p && pv) p.textContent = money(pv.price);
      });
      if (v) {
        if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
        if (submit) {
          submit.disabled = !v.available;
          var txt = v.available ? (submit.dataset.addLabel || 'Add to cart') + ' · ' + money(v.price) : (submit.dataset.soldOut || 'Sold out');
          var t = submit.querySelector('span:not(.loading__spinner):not(.svg-wrapper)'); if (t) t.textContent = txt;
        }
        if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      }
      if (sticky) {
        var sub = sticky.querySelector('[data-phx-sticky-sub]');
        if (sub) sub.textContent = [state.size ? 'Size ' + state.size : null, state.pack, v ? money(v.price) : null].filter(Boolean).join(' · ');
        var sp = sticky.querySelector('[data-phx-sticky-price]'); if (sp && v) sp.textContent = '· ' + money(v.price);
      }
    }

    if (sizeSelect) sizeSelect.addEventListener('change', function () { state.size = sizeSelect.value; render(); });
    packBtns.forEach(function (b) { b.addEventListener('click', function () { state.pack = b.dataset.phxPack; render(); }); });

    var initial = product.variants.find(function (v) { return v.id === Number(dataEl.dataset.selected); }) || product.variants.find(function (v) { return v.available; }) || product.variants[0];
    if (initial) {
      if (sizeIdx >= 0) { state.size = initial.options[sizeIdx]; if (sizeSelect) sizeSelect.value = state.size; }
      if (packIdx >= 0) state.pack = dataEl.dataset.defaultPack || initial.options[packIdx];
    }
    render();

    // gallery
    var mainImg = root.querySelector('[data-phx-gallery-main]');
    var badge = root.querySelector('[data-phx-gallery-badge]');
    root.querySelectorAll('[data-phx-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-phx-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
        if (mainImg) { mainImg.src = b.dataset.phxSrc; mainImg.srcset = b.dataset.phxSrcset || ''; mainImg.alt = b.dataset.phxAlt || ''; }
        if (badge) badge.hidden = b.dataset.phxBadge !== 'true';
      });
    });

    // size guide
    var guide = root.querySelector('dialog[data-phx-size-guide]');
    var guideBtn = root.querySelector('[data-phx-size-guide-open]');
    if (guide && guideBtn) {
      guideBtn.addEventListener('click', function () {
        guide.showModal();
        document.dispatchEvent(new CustomEvent('phoenix:size_guide_open', { detail: { product: product.handle } }));
      });
      guide.querySelector('[data-phx-size-guide-close]').addEventListener('click', function () { guide.close(); });
      guide.addEventListener('click', function (e) { if (e.target === guide) guide.close(); });
    }

    // quiz entry clicks are bound site-wide by the header's analytics bridge; it reads the product handle from here
    window.phxProduct = product.handle;

    // sticky cart: visible once the main add-to-cart button's bottom is above the viewport (prototype rule)
    if (sticky && submit) {
      document.body.classList.add('phx-has-sticky');
      var raf = 0;
      var update = function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { sticky.setAttribute('data-visible', submit.getBoundingClientRect().bottom < 0 ? 'true' : 'false'); });
      };
      update(); window.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update);
      var add = sticky.querySelector('[data-phx-sticky-add]'); if (add) add.addEventListener('click', function () { submit.click(); });
    }
  }

  document.querySelectorAll('[data-phx-main]').forEach(init);
})();
